import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://2a5ef893f653023b6ea94502a6b3244d@o4505483017846784.ingest.us.sentry.io/4509830070403072",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.01,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: true,
        }),
    ],
});
